"use client";

import { type ReactNode } from "react";
import { useCountdownTimer } from "@/components/common/CountdownTimer/useCountdownTimer";
import List from "@/components/common/List";

export enum TimerUnitTypes {
  Days = "days",
  Hours = "hours",
  Minutes = "minutes",
  Seconds = "seconds",
}

export interface CountdownTimerProps {
  date: string;
  renderTimeUnit: (value: number | string, type: TimerUnitTypes) => ReactNode;
  header?: ReactNode;
  time?: string;
  hideSeconds?: boolean;
  mask?: string;
}

const timerUnits = [
  TimerUnitTypes.Days,
  TimerUnitTypes.Hours,
  TimerUnitTypes.Minutes,
  TimerUnitTypes.Seconds,
];

export default function CountdownTimer(props: CountdownTimerProps) {
  const {
    date,
    renderTimeUnit,
    header,
    time,
    hideSeconds,
    mask = "00",
  } = props;
  const timeLeftMap = useCountdownTimer({
    date,
    time,
  });
  const timerUnitTypes = hideSeconds
    ? timerUnits.filter((item) => item !== TimerUnitTypes.Seconds)
    : timerUnits;

  if (timeLeftMap.expired) {
    return null;
  }

  return (
    <>
      {header}
      <List
        items={timerUnitTypes}
        renderItem={(timeType) => {
          const time = timeLeftMap[timeType];
          const timeValue = String(time).padStart(mask.length, "0");

          return renderTimeUnit(timeValue, timeType);
        }}
      />
    </>
  );
}
